import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import MessageUI from '../../widgets/output/MessageUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableRowLinkUI from '../../widgets/layout/LRTableRowLinkUI'
import './SettingsPage.css'

const SettingsPageUI = ({context, messageList, errorList}) =>
  <PrivatePageSF context={context} className='pg_settings'
    messageList={messageList} headerMessageKey='c_settings'
    centered={!messageList && !errorList}
  >
    {
      !messageList &&
      <SpinnerComponentUI />
    }
    {
      errorList &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      messageList &&
      <div>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_settings' />
        <LRTableBodyUI>
          {
            !context.permissions.includes('acc_csr') &&
            <SettingsRowUI context={context} messageList={messageList} messageKey='c_user_settings'
              to={`/settings/user/${context.session.appCode === 'projectapp' ? 'prj' : 'fin'}`}
            />
          }
          <SettingsRowUI context={context} messageList={messageList} messageKey='c_account_settings'
            to={`/settings/account/${context.session.appCode === 'projectapp' ? 'prj' : 'fin'}`}
          />
          {
            context.permissions && context.permissions.includes('acc_view') &&
            <SettingsRowUI context={context} messageList={messageList} messageKey='c_account_users' to='/settings/members' />
          }
          {
            !context.permissions.includes('acc_csr') &&
            <SettingsRowUI context={context} messageList={messageList} messageKey='c_logout' to='/settings/logout' />
          }
          {
            context.permissions.includes('acc_csr') &&
            <SettingsRowUI context={context} messageList={messageList} messageKey='c_exit_account' to='/settings/logout' />
          }
        </LRTableBodyUI>
      </div>
    }
  </PrivatePageSF>

const SettingsRowUI = ({context, messageList, messageKey, to}) =>
  <LRTableRowLinkUI
    context={context}
    to={to}
    left={<label><MessageUI messageList={messageList} messageKey={messageKey} /></label>}
    right={<div className="icon icon-caret-right"></div>}
  />

export default SettingsPageUI
